import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router";
import EDCMainPanel from "../../Components/EDC/EDCMainPanel";
import LUPManagementSidebar from "./LUPManagementSidebar";
import ResizerXManager from "../../Components/ResizerXManager/ResizerXManager";
import { ResizableX, ResizableY } from "../Modules/ResizeTable/Layouts";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { ResizablexContext } from "../Modules/ResizeTable/ResizeTable";
import ProjectManagement from "./ProjectManagement/ProjectManagement";
import LUPManagementDashboard from "./Dashboard/LUPManagementDashboard";
import LibraryManagement from "./LibraryManagement/LibraryManagement";
import DatasetManagement from "./LibraryManagement/DatasetManagement";
import StudyDetails from "./StudyManagement/StudyDetails";
import AuditTrial from "./StudyManagement/AuditTrial";
import ProjectLogs from "./ProjectManagement/ProjectLogs";
import ProjectOutputs from "./ProjectManagement/ProjectOutputs";
import PackageDetails from "./ProjectManagement/PackageDetails";
import LocalDatasetManagement from "./LibraryManagement/LocalDatasetManagement";
import FileManagement from "./FileManagement/FileManagement";
import RecycleBin from "./FileManagement/RecycleBin";
import S3DatasetManagement from "./LibraryManagement/S3DatasetManagement";

const LUPManagement = () => {
  const [studyTabs, setStudyTabs] = useState([]);
  const [openModule, setOpenModule] = useState("lupProject");
  const [showSidebar, setShowSidebar] = useState(true);
  const { studyId } = useParams();
  const [resizingColumn, setResizingColumn] = useState(null);
  const startX = useRef(0);
  const startWidth = useRef(0);
  const tableRef = useRef(null);
  const [collapseSidebar, setCollpaseSidebar] = useState(false);
  const [fileFolderUpdater, setFileFolderUpdater] = useState("");
  const resizableX = useContext(ResizablexContext);

  useEffect(() => {
    resizableX();
  });

  useEffect(() => {
    const onMouseMove = (e) => {
      if (resizingColumn !== null) {
        const width = startWidth.current + (e.pageX - startX.current);
        const th = tableRef.current.querySelector(
          `th:nth-child(${resizingColumn + 1})`
        );
        th.style.width = `${width}px`;
        tableRef.current.classList.add("resizing");
      }
    };

    const onMouseUp = () => {
      setResizingColumn(null);
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    if (resizingColumn !== null) {
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, [resizingColumn]);

  const onMouseDown = (e, columnIndex) => {
    setResizingColumn(columnIndex);
    startX.current = e.pageX;
    startWidth.current = e.target.offsetWidth;
    document.body.style.userSelect = "none";
    tableRef.current.querySelectorAll("th").forEach((column, index) => {
      if (index !== columnIndex) {
        column.style.width = `${column.offsetWidth}px`;
      }
    });
  };

  const handleAddNewTab = (studyTabName, icon, studyTabId, ids) => {
    let newTab = {
      studyTabId: studyTabId,
      studyTabName: studyTabName,
      icon: icon,
      openDT: new Date(),
      status: "active",
      ids: ids
    };
    const updatedTabs = studyTabs?.map((studyTab) => ({
      ...studyTab,
      status: "inactive",
    }));
    const existTab = studyTabs?.some(
      (studyTab) => studyTab.studyTabId === studyTabId
    );
    if (existTab) {
      updatedTabs.forEach((element) => {
        if (element.studyTabId === studyTabId) {
          element.status = "active";
          element.studyTabName = studyTabName;
          element.ids = ids;
        }
      });
      setStudyTabs(updatedTabs || []);
    } else {
      setStudyTabs([...updatedTabs, newTab] || []);
    }
  };

  const checkActiveTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId === studyTabId && item.status === "active"
    );
  };

  const checkActiveTabData = (studyTabId) => {
    return studyTabs?.find(
      (item) => item.studyTabId?.includes(studyTabId) && item.status === "active"
    );
  };

  const checkHomeActiveTab = () => {
    return studyTabs?.some((item) => item.status === "active");
  };

  const checkActiveMultiTab = (studyTabId) => {
    return studyTabs?.some(
      (item) => item.studyTabId?.includes(studyTabId) && item.status === "active"
    );
  };

  const handleDeleteTab = (studyTabId) => {
    const updatedStudyTabs = studyTabs?.filter(
      (studyTab) => studyTab.studyTabId !== studyTabId
    );
    setStudyTabs(updatedStudyTabs);
  };

  const activeStudyTab = studyTabs?.some((item) => item.status === "active");

  useEffect(() => {
    const savedStudyTabs = JSON.parse(localStorage.getItem("studyTabs"));
    if (savedStudyTabs) {
      setStudyTabs(savedStudyTabs || []);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("studyTabs", JSON.stringify(studyTabs));
  }, [studyTabs]);

  return (
    <>
      <Navbar setOpenModule={setOpenModule} setShowSidebar={setShowSidebar} />
      <ResizableX>
        {showSidebar && (
          <>
            <div style={{ width: collapseSidebar ? 45 : 280 }}>
              <section className="middle-content">
                <div className="sidebar" id="myGroup">
                  <div className="menus">
                    <LUPManagementSidebar
                      handleAddNewTab={handleAddNewTab}
                      checkActiveTab={checkActiveTab}
                      studyId={studyId}
                      tableRef={tableRef} onMouseDown={onMouseDown}
                      checkActiveTabData={checkActiveTabData}
                      openModule={openModule}
                      collapseSidebar={collapseSidebar}
                      setFileFolderUpdater={setFileFolderUpdater}
                      fileFolderUpdater={fileFolderUpdater}
                      handleDeleteTab={handleDeleteTab}
                    />
                  </div>
                </div>
              </section>
            </div>
            <ResizerXManager collapseSidebar={collapseSidebar} />
          </>
        )}
        <ResizableY>
          <section className="middle-content " id="dashboard-section">
            <div className="inner-cont">
              <EDCMainPanel
                setStudyTabs={setStudyTabs}
                studyTabs={studyTabs}
                activeStudyTab={activeStudyTab}
                showSidebar={showSidebar}
                collapseSidebar={collapseSidebar}
                setCollpaseSidebar={setCollpaseSidebar}
              />
              {!checkHomeActiveTab() && <LUPManagementDashboard tableRef={tableRef} onMouseDown={onMouseDown} />}

              {checkActiveTab("projectManagement") && (
                <ProjectManagement tableRef={tableRef} onMouseDown={onMouseDown} />
              )}

              {checkActiveTab("fileManagement") && (
                <FileManagement tableRef={tableRef}
                  onMouseDown={onMouseDown}
                  ids={checkActiveTabData("fileManagement")?.ids}
                  handleAddNewTab={handleAddNewTab}
                  setFileFolderUpdater={setFileFolderUpdater}
                  fileFolderUpdater={fileFolderUpdater}
                />
              )}

              {checkActiveTab("fileManagementRecycleBin") && (
                <RecycleBin
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                  ids={checkActiveTabData("fileManagementRecycleBin")?.ids}
                  handleAddNewTab={handleAddNewTab}
                  setFileFolderUpdater={setFileFolderUpdater}
                  fileFolderUpdater={fileFolderUpdater}
                />
              )}

              {checkActiveMultiTab("libraryManagement") && (
                <LibraryManagement
                  ids={checkActiveTabData("libraryManagement")?.ids}
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveMultiTab("datasetManagement") && (
                <DatasetManagement
                  ids={checkActiveTabData("datasetManagement")?.ids}
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveMultiTab("readS3DatasetManagement") && (
                <S3DatasetManagement
                  ids={checkActiveTabData("readS3DatasetManagement")?.ids}
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveMultiTab("readLocalDatasetManagement") && (
                <LocalDatasetManagement
                  ids={checkActiveTabData("readLocalDatasetManagement")?.ids}
                  tableRef={tableRef}
                  onMouseDown={onMouseDown}
                />
              )}
              {checkActiveMultiTab("projectManagement") && (
                <ProjectManagement
                  handleAddNewTab={handleAddNewTab}
                  ids={checkActiveTabData("projectManagement")?.ids}
                />
              )}
              {checkActiveMultiTab("projectLogData") && (
                <ProjectLogs
                  ids={checkActiveTabData("projectLogData")?.ids}
                />
              )}
              {checkActiveMultiTab("projectOutputData") && (
                <ProjectOutputs
                  ids={checkActiveTabData("projectOutputData")?.ids}
                />
              )}
              {checkActiveMultiTab("packageData") && (
                <PackageDetails
                  ids={checkActiveTabData("packageData")?.ids}
                />
              )}

              {checkActiveTab("studyDetail") && <StudyDetails />}

              {checkActiveTab("auditLogs") && (
                <AuditTrial tableRef={tableRef} onMouseDown={onMouseDown} />
              )}

            </div>
          </section>
        </ResizableY>
      </ResizableX>
      <Footer />
    </>
  );
};

export default LUPManagement;
